import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function ModelIcon({ ...props }) {
  return (
    <SvgIcon width="16" height="18" viewBox="0 0 16 18" {...props}>
      <path d="M1.94926 6.07173C1.28261 5.69079 0.453125 6.17215 0.453125 6.93998V13.2423C0.453125 13.4282 0.552763 13.5999 0.714278 13.6922L6.21219 16.8339C6.87885 17.2149 7.70833 16.7335 7.70833 15.9657V9.94295C7.70833 9.5841 7.51605 9.25275 7.20447 9.07471L1.94926 6.07173Z" />
      <path d="M9.24867 9.07471C8.9371 9.25275 8.74481 9.5841 8.74481 9.94295V15.9657C8.74481 16.7335 9.5743 17.2149 10.241 16.8339L15.7389 13.6922C15.9004 13.5999 16 13.4282 16 13.2423V6.93998C16 6.17215 15.1705 5.69079 14.5039 6.07173L9.24867 9.07471Z" />
      <path d="M8.47034 0.0609697C8.31795 -0.0203232 8.13501 -0.0203232 7.98262 0.0609697L2.16364 3.24604C1.47772 3.62149 1.46871 4.6035 2.14762 4.99147L7.73034 8.18176C8.03778 8.35746 8.41521 8.35746 8.72265 8.18176L14.3054 4.99147C14.9843 4.6035 14.9753 3.62149 14.2893 3.24604L8.47034 0.0609697Z" />
    </SvgIcon>
  );
}
